import React from 'react';
import { HelmetProvider } from "react-helmet-async";
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import LandingYLF from './LandingYLF';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
	<HelmetProvider>		
		<BrowserRouter>
			<LandingYLF />
		</BrowserRouter>	
	</HelmetProvider>  
  </React.StrictMode>
);
